import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        productsGrid: {
            spacingX: remCalc(8),
            spacingY: remCalc(8),
            alignItems: 'stretch',
            gridAutoRows: '1fr',
        },
        refinementsStack: {
            display: 'flex',
            direction: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 'small.sm',
            height: 'auto',
            borderColor: 'gray.100',
        },
        refinementsDivider: {
            marginTop: {
                base: remCalc(16),
                lg: remCalc(24),
            },
            marginBottom: {
                base: remCalc(11),
                lg: 0,
            },
            color: 'background.light',
        },
        refinementsTabContainer: {
            width: '100%',
            paddingTop: 'xsmall-1.base',
            paddingBottom: 'xxsmall-1.base',
        },
        manualsTabPanel: {
            display: 'flex',
            flexDir: 'column',
            gap: 'small.base',
            padding: {
                base: `${remCalc(24)} ${remCalc(16)} ${remCalc(16)}`,
                lg: `${remCalc(40)} ${remCalc(16)} ${remCalc(16)}`,
            },
        },
        editorialComponentsContainer: {
            layerStyle: 'page',
        },
    },
}
